export class Agenda {

    public id: string = "0";

    public acceptInvite: boolean = false;
    
    public member_id: string;
    public member_name: string;
    public member_state: string = "";
    public member_country: string = "";

    public event_id: string;
    public event_name: string;

    public day_id: string;
    public day_date: Date;
    public day_name: string;

    public depto_id: string = '';
    public depto_name: string = '';

    public activity_id: string;
    public activity_name: string;
    public activity_startTime: string;

    public topic_id: string;
    public topic_name: string;
    public topic_startTime: string;
    public topic_duration: number;
   
    public role_id: string;
    public role_name: string;

    public level: string;

    public staff: any;

    public deleted: boolean;

    ////////////////////////////

    public requireConfirm: boolean = false;
    public dateConfirmed: Date;// = null;

    public requireSchedule: boolean = false;
    public scheduled_date: Date;// = null;
    public scheduled_hour: string;// = '';

    constructor() {}

}